<script setup lang="ts">
import type { ChampionshipRegistrationSelectTeamTask } from "@/model/championship/championship-registration-select-team-task"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient, useHttpGet } from "@/vf"
import { toRefs } from "vue"
import ChampionshipRegistrationApprovalStateList from "./ChampionshipRegistrationApprovalStateList.vue"
import ChampionshipRegistrationResetButton from "./ChampionshipRegistrationResetButton.vue"
import ChampionshipRegistrationTeamList from "./ChampionshipRegistrationTeamList.vue"
import type { ChampionshipRegistrationApproveData } from "./championship-registration"

const props = defineProps<TasksProps<ChampionshipRegistrationSelectTeamTask>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const { task } = toRefs(props)
const { data } = await useHttpGet<ChampionshipRegistrationApproveData>(
    `/championship/registration/${task.value.organizationId}/approve/${task.value.id}`,
)
const http = useHttpClient()

/*─────────────────────────────────────┐
│  submit                              │
└─────────────────────────────────────*/
async function submit(allTeamsDecided: boolean, approvalStates: Record<string, string>) {
    if (!allTeamsDecided) {
        return
    }

    await http.post(`/championship/registration/${data.value.registrationId}/approve`, {
        teams: approvalStates,
    })
    emit("updated")
}
</script>
<template>
    <div class="p-5">
        <div v-if="viewMode === 'customer'">
            <div class="alert alert-info mb-5 mt-3">
                {{ $t("@tasks:tasks.championship_registration.approve.approval_pending") }}
            </div>

            <ChampionshipRegistrationTeamList
                :teams="data.teams"
                :view-mode="props.viewMode"
            ></ChampionshipRegistrationTeamList>

            <div class="mt-5">
                <ChampionshipRegistrationResetButton
                    :registrationId="data.registrationId"
                    @resetted="emit('updated')"
                />
            </div>
        </div>

        <div v-else>
            <ChampionshipRegistrationApprovalStateList v-bind="{ data, teams: data.teams, viewMode: props.viewMode }">
                <template #bottom="{ allTeamsDecided, approvalStates }">
                    <div class="d-flex justify-content-end">
                        <button
                            class="btn btn-primary mt-5"
                            :disabled="!allTeamsDecided"
                            @click="submit(allTeamsDecided, approvalStates)"
                        >
                            Überprüfung finalisieren
                        </button>
                    </div>
                </template>
            </ChampionshipRegistrationApprovalStateList>
        </div>
    </div>
</template>
